import React from 'react';
// TailwindCSS styles are applied directly via className strings
import Header from './Header';
import FeaturesSection from './FeaturesSection';
import ParkingSection from './ParkingSection';
import BenefitsSection from './BenefitsSection';
import HeroSection from './HeroSection';
import ShoppingIntroSection from './ShoppingIntroSection';
import ShoppinsSection from './ShoppinsSection';
import LojistaSection from './LojistaSection';
import CookieConsentBanner from '../../components/CookieConsentBanner';
import Footer from '../../components/Footer';

const LandingPage = () => (
  <div className="flex flex-col min-h-screen bg-[#efeae7] font-sans">
    {/* Header */}
    <Header />

    {/* Hero Section */}
    <HeroSection />

    {/* Shopping Intro Section */}

    {/* Features Section */}
    <FeaturesSection />
    <ParkingSection />
    <BenefitsSection />
    <ShoppinsSection />
    <ShoppingIntroSection />
    <LojistaSection />

    {/* Footer */}
    <Footer />

    <CookieConsentBanner />
  </div>
);

export default LandingPage;
